export type EncodingModeItem = { value: number | null; text: string };

/** Aggregator direction encoding_mode: null or 0–8 (no auto/-1). */
export const ENCODING_MODE_ITEMS: EncodingModeItem[] = [
  { value: null, text: 'из smpp (без изменения)' },
  { value: 0, text: 'GSM 7-bit' },
  { value: 1, text: 'IA5 ASCII' },
  { value: 3, text: 'Latin-1 (ISO-8859-1)' },
  { value: 5, text: 'JIS (Shift_JIS)' },
  { value: 6, text: 'Cyrillic (ISO-8859-5)' },
  { value: 7, text: 'Latin/Hebrew (ISO-8859-8)' },
  { value: 8, text: 'UCS2 (UTF-16BE)' },
];

/** Stream/SMPP client decoding_mode: also allows -1 (auto). */
export const DECODING_MODE_ITEMS: EncodingModeItem[] = [
  { value: null, text: 'из smpp (без изменения)' },
  { value: -1, text: 'Авто' },
  { value: 0, text: 'GSM 7-bit' },
  { value: 1, text: 'IA5 ASCII' },
  { value: 3, text: 'Latin-1 (ISO-8859-1)' },
  { value: 5, text: 'JIS (Shift_JIS)' },
  { value: 6, text: 'Cyrillic (ISO-8859-5)' },
  { value: 7, text: 'Latin/Hebrew (ISO-8859-8)' },
  { value: 8, text: 'UCS2 (UTF-16BE)' },
];

/** Normalize API value: null or integer 0–8; anything else → null. */
export function normalizeEncodingMode(value: unknown): number | null {
  if (value == null || value === '') return null;
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isInteger(n) || n < 0 || n > 8) return null;
  return n;
}
